import styled from "styled-components";

import { layoutWidth } from '@/components/Base/css'

export const Root = styled.div`
`

export const Chunk1 = styled.div`
  padding: 125px 0 0;
  /* background: linear-gradient(178deg, #E9E9E9 0%, #FCFCFC 100%); */

  &.sub-mobile {
    padding: 76px 12px 0;

    .top-tip {
      height: 25px;
    }

    @keyframes marqueeAnim {
      0% {
        transform: translateX(250px);
      }
      100% {
        transform: translateX(-370px);
      }
    }

    .tt {
      width: 100%;
      font-size: 12px;

      & > span {
        max-width: 85%;
        overflow: hidden;

        @media (max-width: 460px) {
          span {
            display: block;
            white-space: nowrap;
            animation: marqueeAnim 15s linear 0s infinite;
          }
        }
      }

      svg {
        margin: 0 5px;
      }
    }

    .slogn {
      margin-top: 32px;

      h2 {
        font-size: 28px;
        line-height: 33px;
        width: 320px;
        margin: 0 auto;
        font-family: Inter, PingFang SC, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
      }

      h3 {
        margin-top: 10px;
        font-size: 18px;
        line-height: 22px;
      }

      p {
        margin: 20px auto 0;
        font-size: 12px;
        line-height: 16px;
      }
    }
  }

  .top-tip {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    background: #F7E7E5;
    border-radius: 20px 20px 20px 20px;

    .tt {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #E9361B;
      cursor: pointer;
    }

    svg {
      margin: 0 10px;
    }
  }

  .slogn {
    margin-top: 105px;
    text-align: center;
    
    h2 {
      color: #D13018;
      line-height: 64px;
      font-size: 54px;
      font-family: Inter-bold;
    }

    h3 {
      margin-top: 15px;
      line-height: 50px;
      font-size: 42px;
      color: #333333;
    }

    p {
      max-width: 940px;
      margin: 40px auto 0;
      line-height: 20px;
      font-size: 16px;
      color: #777776;
    }
  }

  &.sub-mobile {
    .links {
      margin-top: 30px;

      .to-dmail {
        margin-right: 0;

        svg {
          margin-left: 5px;
        }
      }
    } 
  }

  .links {
    margin-top: 60px;
    display: flex;
    justify-content: center;

    .to-dmail {
      margin-right: 40px;

      svg {
        margin-left: 10px;
      }
    }
  }

  &.sub-mobile {
    .datas {
      margin-top: 35px;
      background: none;
      flex-wrap: wrap;
      height: auto;
      padding: 0;

      span {
        margin-top: 3px;
        line-height: 1;
        font-size: 12px;
        color: #666;
      }

      p {
        font-size: 20px;
        line-height: 24px;
        margin: 10px 0 0;
      }

      .total {
        display: flex;
        flex-direction: column-reverse;
        justify-content: center;
        align-items: center;
        width: 50%;
        height: 88px;
        margin-bottom: 16px;
        background: #F5F5F5;
        box-sizing: border-box;
        position: relative;

        &:nth-child(1), &:nth-child(3) {
          border-radius: 10px 0 0 10px;

          &::after {
            content: '';
            position: absolute;
            top: 15px;
            bottom: 15px;
            right: 0;
            width: 1px;
            background-color: #eee;
          }
        }

        &:nth-child(2), &:nth-child(4) {
          border-radius: 0 10px 10px 0;
        }
      }
    }
  }

  .datas {
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-top: 125px;
    height: 160px;
    padding: 0 10px;
    background: #F5F5F5;
    border-radius: 10px;
    text-align: center;

    .total {
      min-width: 160px;
    }

    p {
      margin-bottom: 10px;
      font-size: min(42px, 3.33vw);
      line-height: min(50px, 3.89vw);
      color: #333;
      font-weight: bold;
    }

    span {
      display: block;
      line-height: 20px;
      font-size: 16px;
    }
  }
`

export const Chunk2 = styled.div`
  padding: 100px 0;

  &.sub-mobile {
    padding: 20px 0 0;

    .center {
      padding: 0 12px;
    }

    h2 {
      font-size: 20px;
      line-height: 24px;
      text-align: left;
    }
  }

  h2 {
    font-size: min(42px, 2.92vw);
    line-height: min(48px, 3.33vw);
    text-align: center;
  }

  .tab-tags {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 65px;
    margin: 40px auto;
    background: #333333;
    border-radius: 42px;
    padding: 10px;
    box-sizing: border-box;

    strong {
      line-height: 45px;
      padding: 0 25px;
      border-radius: 24px;
      text-align: center;
      font-size: 18px;
      white-space: nowrap;
      color: #fff;
      cursor: pointer;
      transition: all 0.4s ease-out 0s;

      &:hover {
        color: rgba(255, 255, 255, .6);
      }
      &.on {
        background-color: rgba(255, 255, 255, .9);
        color: #333333;
      }
    }
  }

  &.sub-mobile {
    .tab-wrapper {
      .tab-item {
        width: auto;
        height: auto;
        margin: 0 0 28px;
        overflow: hidden;
        position: static;
        opacity: 0;
        display: none;
        transform: none;
        padding: 0;
        transition: height .4s ease-out 0s;

        @keyframes show-item {
          0% {
            opacity: 0;
          }
          100% {
            opacity: 1;
          }
        }

        &.on {
          display: block;
          animation: show-item 0.5s ease-in 1;
          animation-fill-mode: forwards;
        }
      }

      .tab-market {
        .thumb {
          position: static;
          left: auto;
        }
      }

      .thumb {
        img {
          margin: 35px auto 0;
          display: block;
        }
      }

      .info {
        width: auto;
        margin-top: 40px;
        
        h3 {
          font-size: 20px;
        }

        p {
          margin-top: 20px;
          font-size: 12px;
          line-height: 16px;
        }

        .actions {
          margin-top: 30px;

          .filled-red {
            height: 35px;
            padding: 0 15px;
          }

          .more {
            margin-left: 25px;
            font-size: 14px;
          }
        }
      }
    }

    .tab-list {
      transition: none;
      width: auto;
      height: auto;
    }

    .tab-tag {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 20px;
      height: 40px;
      padding: 0 20px;
      background-color: #F5F5F5;
      border-radius: 10px;
      font-size: 14px;
      color: #333;

      &.on {
        background-color: #333333;
        color: #fff;

        svg {
          transform: rotate(180deg);
        }
      }

      svg {
        /* transition: transform .3s ease-out 0s; */
      }
    }
  }

  .tab-wrapper {
    position: relative;

    .blank {
      position: absolute;
      top: 300px;
    }

    .tab-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 30px;
      opacity: 0;
      transform: scale(0);

      @keyframes tab-show {
        0% {
          opacity: 0;
          transform: scale(0);
        }
        20% {
          opacity: 0;
          transform: scale(1);
        }
        100% {
          opacity: 1;
          transform: scale(1);
        }
      }

      &.on {
        animation: tab-show 0.5s ease-in 1;
        animation-fill-mode: forwards;
      }
    }
  }

  .tab-list {
    position: relative;
    width: 1200px;
    height: 400px;
    transition: 1s;
  }

  .tab-item {
    position: absolute;
    width: 1200px;
    height: 400px;
    box-sizing: border-box;
    left: 0;
    right: 0;
    top: 0;
    z-index: 1;

    &.show {
      .thumb, .info {
        opacity: 1;
        transform: none;
      }
    }
  }

  .tab-market {
    .thumb {
      position: relative;
      left: 80px;
    }
  }

  .info {
    width: 590px;
    
    h3 {
      font-size: min(42px, 2.92vw);
    }
    p {
      margin-top: 35px;
      font-size: 16px;
      line-height: 20px;
    }
    .actions {
      margin-top: 70px;
      display: flex;
      align-items: center;

      .filled-red {
        padding: 0 20px;
        height: 40px;
      }

      .more {
        margin-left: 50px;
        color: #333333;
        cursor: pointer;

        &:hover {
          text-decoration: underline;
        }
      }
    }

  }

  &.sub-mobile {
    .chains {
      margin-top: 35px;
      padding-left: 22px;

      img {
        margin-right: 22px;
      }
    }

    .wallets {
      margin-top: 22px;
      padding-right: 15px;

      img {
        margin-left: 50px;
      }
    }
  }

  .chains, .wallets {
    overflow: hidden;

    div {
      display: flex;
      align-items: center;
      flex-wrap: nowrap;

      img {
        flex-shrink: 0;
      }
    }
  }

  .chains {
    margin-top: 60px;
    padding-left: 30px;

    img {
      margin-right: 30px;
    }
  }

  .wallets {
    display: flex;
    flex-direction: row-reverse;
    margin-top: 45px;
    padding-right: 30px;

    img {
      margin-left: 100px;
      border-radius: 50%;
    }
  }
`

export const Chunk3 = styled.div`
  padding: 80px 0;
  background: #333;
  color: #fff;

  &.sub-mobile {
    margin-top: 30px;
    padding: 30px 0 20px;

    .center {
      width: auto;
      padding: 0 12px;
    }

    h2 {
      font-size: 20px;
      line-height: 24px;
      font-weight: bold;
    }

    .desc {
      margin: 15px 0 20px;
      font-size: 12px;
      line-height: 16px;

      .start {
        align-items: start;

        a {
          margin-left: 20px;
          height: 24px;
          padding: 0 10px;
          font-size: 12px;
          white-space: nowrap;

          svg {
            margin-left: 5px;
          }
        }
      }
    }

    .protocol {
      height: auto;
      padding: 25px 0;
    }
  }

  .center {
    width: 1140px;
  }

  h2 {
    font-size: min(42px, 2.92vw);
    line-height: min(48px, 3.33vw);
    font-weight: normal;
  }

  .desc {
    margin: 30px 0 40px;
    font-size: 16px;
    line-height: 26px;
    color: #ccc;

    .start {
      display: flex;
      align-items: center;
      justify-content: space-between;

      a {
        height: 32px;
        padding: 0 15px;
        font-size: 15px;
        font-weight: normal;

        svg {
          margin-left: 8px;
        }
      }
    }
  }

  .protocol {
    height: 410px;
    background: #222423;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`

export const Chunk4 = styled.div`
  padding: 100px 0 80px;

  &.sub-mobile {
    padding: 35px 12px 25px;

    h2 {
      font-size: 20px;
      line-height: 24px;
    }

    .supporters {
      margin-top: 25px;

      li {
        width: calc((100% - 24px) / 3);
        height: auto;
        margin: 0 12px 20px 0!important;

        &:nth-child(3n) {
          margin-right: 0!important;
        }

        img {
          width: 100%;
          display: block;
        }
      }
    }

    .partners {
      margin-top: 5px;

      li {
        width: 28px;
        height: 28px;

        img {
          width: 100%;
        }
      }
    }
  }

  h2 {
    font-size: min(42px, 2.92vw);
    line-height: min(48px, 3.33vw);
    text-align: center;
  }

  li {
    /* transition: transform .3s ease-out; */

    &:hover {
      transform: scale(1.15);
    }
  }

  .supporters {
    display: flex;
    flex-wrap: wrap;
    margin-top: 70px;

    li {
      width: 216px;
      height: 60px;
      margin-right: 30px;
      margin-bottom: 70px;
      background: #F5F5F5;
      border-radius: 10px 10px 10px 10px;
      /* transform-origin: center top; */

      /* &:nth-child(1), &:nth-child(2), &:nth-child(6), &:nth-child(7) {
        transform-origin: right top;
      }

      &:nth-child(4), &:nth-child(5), &:nth-child(9), &:nth-child(10) {
        transform-origin: left top;
      } */

      &:nth-child(5n) {
        margin-right: 0;
      }
    }
  }

  .partners {
    display: flex;
    justify-content: space-between;

    li {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      background: #F5F5F5;

      /* &:nth-child(-n+4) {
        transform-origin: right center;
      }

      &:nth-child(n+4) {
        transform-origin: left center;
      } */
      
      &:last-child {
        margin-right: 0;
      }
    }
  }
`

export const Chunk5 = styled.div`
  padding: 80px 0;
  background: #F5F5F5;

  &.sub-mobile {
    padding: 25px 0 15px;
    overflow: hidden;

    .title {
      padding: 0 12px;

      a {
        font-size: 14px;
      }
    }

    h2 {
      font-size: 20px;
      line-height: 24px;
      font-weight: bold;
    }

    .events {
      margin-top: 14px;
      padding: 10px 12px;
      overflow-x: auto;

      ul {
        width: calc(240% + 45px);
      }

      li {
        width: calc((100% - 45px) / 3);
        margin-right: 15px;
        padding: 8px;
        flex-shrink: 0;

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }

  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;

    a {
      color: #C02C16;
      font-size: 18px;
      cursor: pointer;
    }
  }

  h2 {
    font-size: min(42px, 2.92vw);
    line-height: min(48px, 3.33vw);
    font-weight: normal;
  }

  .events {
    margin-top: 40px;
  }
`

export const Chunk6 = styled.div`
  .center {
    padding: 80px 0 80px;
    border-top: 1px solid #eee;
  }

  &.sub-mobile {
    padding: 25px 0 15px;

    .center {
      margin: 0 12px;
      padding: 0 0 10px;
      border: none;
    }

    .title {
      padding: 0 12px;

      a {
        font-size: 14px;
      }
    }

    h2 {
      font-size: 20px;
      line-height: 24px;
      font-weight: bold;
    }

    .nfts-3d {
      margin-top: 60px;
      padding: 82px 12px 20px;
      border-radius: 10px;

      & > img {
        top: -36px;
        left: 50%;
        right: auto;
        transform: translateX(-50%);
      }

      .slide {
        width: 100%;
        padding: 0;

        & > div {
          display: flex;
          align-items: center;
          flex-wrap: nowrap;
        }
      }

      li {
        width: 70px;
        margin-right: 70px;
      
        p {
          margin-top: 10px;
          font-size: 12px;
        }
      }
    }
  }

  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;

    a {
      color: #C02C16;
      font-size: 18px;
      cursor: pointer;
    }
  }

  h2 {
    font-size: min(42px, 2.92vw);
    line-height: min(48px, 3.33vw);
    font-weight: bold;
  }

  .nfts-3d {
    margin-top: 115px;
    padding: 45px 100px;
    background-color: #222423;
    border-radius: 20px;
    position: relative;
    color: #fff;
    cursor: pointer;

    & > img {
      position: absolute;
      top: -60px;
      right: 60px;
    }

    .slide {
      overflow: hidden;
      width: 700px;
      padding: 0 20px;

      & > div {
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
      }
    }

    .item {
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
    }

    ul {
      display: flex;
      align-items: center;
    }

    li {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 86px;
      margin-right: 170px;

      /* strong {
        margin: 18px 0 6px;
        font-size: 16px;
      } */

      p {
        white-space: nowrap;
        margin-top: 20px;
        color: #999999;
        font-size: 14px;
      }
    }
  }

`